import { ky } from './ky';

export default class FeedButtonService {

  async click(feedSid: string, buttonId: number) {
    return await ky.post(`v1/feeds/${feedSid}/buttons/${buttonId}`);
  }
}
